module.exports = __webpack_public_path__ + "static/media/Copy.9e9c8501.svg";